import { Controller } from "@hotwired/stimulus";
import { Notyf } from "notyf";

export default class extends Controller {
  static targets = ["lockMessage"];

  connect() {
    console.log("cards#connect");

    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    const tooltipList = [...tooltipTriggerList].map(
      (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
    );
  }

  selected(ev) {
    let url = ev.params.url;
    location.href = url;
  }

  practiceTestSelected(ev) {
    ev.preventDefault();

    if (ev.currentTarget.classList.contains("upgrade")) {
      this.showUpgradeModal();
    } else if (ev.currentTarget.classList.contains("pending")) {
      const notyf = new Notyf({
        duration: 4000,
        position: { x: "right", y: "top" },
      });

      notyf.error({
        message:
          "Please complete the previous practice tests before proceeding to a new one.",
        dismissible: true,
      });

      document.getElementById(ev.params.lockId).classList.add("show");
    } else {
      let url = ev.params.url;
      location.href = url;
    }
  }

  showUpgradeModal() {
    const modalElement = document.getElementById("upsellModal");
    if (!modalElement) return;

    // Initialize modal and timer properties
    if (!this.isInitialized) {
      this.timer = null;
      this.timeLeft = null;
      this.modal = null;
      this.isInitialized = false;

      this.modal = new bootstrap.Modal(modalElement);

      // Set up modal event listener
      modalElement.addEventListener("hidden.bs.modal", () => {
        this.clearTimer();
      });

      this.isInitialized = true;
    }

    // Start timer only if it's not already running
    if (!this.timer) {
      this.startTimer(5, 0); // 5 minutes countdown
    }

    this.modal.show();
  }

  formatTime(minutes, seconds) {
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  }

  updateCountdown() {
    if (this.timeLeft.seconds === 0) {
      if (this.timeLeft.minutes === 0) {
        this.clearTimer();
        document.getElementById("countdown").textContent = "00:00";
        return;
      }
      this.timeLeft.minutes--;
      this.timeLeft.seconds = 59;
    } else {
      this.timeLeft.seconds--;
    }

    document.getElementById("countdown").textContent = this.formatTime(
      this.timeLeft.minutes,
      this.timeLeft.seconds
    );
  }

  startTimer(minutes = 5, seconds = 0) {
    if (!this.timer) {
      this.timeLeft = { minutes, seconds };

      // Update display immediately
      document.getElementById("countdown").textContent = this.formatTime(
        this.timeLeft.minutes,
        this.timeLeft.seconds
      );

      // Start countdown
      this.timer = setInterval(() => this.updateCountdown(), 1000);
    }
  }

  clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
